<template>
    <v-list-item :to="{ name: 'M_Passwords' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-form-textbox-password</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title>Password</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemPassword',
    props: {
        disabled: Boolean,
    }
}
</script>